// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ChannelEndpoint, ChannelEndpointT, verifyChannelEndpoint } from "./channel-endpoint";
import { ChannelMode } from "./channel-mode";
import { ChannelType } from "./channel-type";
import { ControlRoute, ControlRouteT, verifyControlRoute } from "./control-route";
import { ControlWriteMode } from "./control-write-mode";
import { MergePolicy } from "./merge-policy";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";
import { Message, MessageT, verifyMessage } from "../ln2/message";

/**
 * Full channel record matching the `channels` `PostgreSQL` table.
 */
export class Channel implements flatbuffers.IUnpackableObject<ChannelT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Channel {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsChannel(bb: flatbuffers.ByteBuffer, obj?: Channel): Channel {
    return (obj || new Channel()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsChannel(bb: flatbuffers.ByteBuffer, obj?: Channel): Channel {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Channel()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  serverId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  leadingZeroesId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): ChannelType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ChannelType.TCP;
  }

  /**
   * Connection type uses the same ChannelType enum in the database.
   */
  connectionType(): ChannelType {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ChannelType.TCP;
  }

  index(): string | null;
  index(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  index(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  baudRate(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 9600;
  }

  heartbeatFrequency(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  vendorSocketAddress(): string | null;
  vendorSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  routableSocketAddress(): string | null;
  routableSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  routableSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  reportingSocketAddress(): string | null;
  reportingSocketAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  reportingSocketAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  heartbeatMessage(obj?: Message): Message | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset
      ? (obj || new Message()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Multiplexing mode. Defaults to SINGLE (back-compat with all existing channels).
   */
  mode(): ChannelMode {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ChannelMode.SINGLE;
  }

  /**
   * Merge conflict-resolution policy. Meaningful only in MERGE/MIXED modes.
   */
  mergePolicy(): MergePolicy {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MergePolicy.LAST_WRITE_WINS;
  }

  /**
   * Ordered list of endpoints for non-SINGLE modes. For SINGLE channels
   * this vector contains exactly one endpoint mirroring the legacy address fields.
   */
  endpoints(index: number, obj?: ChannelEndpoint): ChannelEndpoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset
      ? (obj || new ChannelEndpoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  endpointsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * UUID of the currently active endpoint as reported by VTS (nullable).
   * Updated via the writeback API; read-only from the channel perspective.
   */
  activeEndpointId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Timestamp set by the backfill migration once it has synthesized the
   * SINGLE-mode endpoint for this channel. Used as an idempotency guard.
   */
  backfilledEndpointsAt(): string | null;
  backfilledEndpointsAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  backfilledEndpointsAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Timestamp of the most recent VTS failover advance on this channel.
   */
  lastFailoverAt(): string | null;
  lastFailoverAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  lastFailoverAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC UA connection endpoint (opc.tcp://host:port/path). Only meaningful for
   * channels serving OPC UA banks. The adapter Mapping is bank-agnostic, so the
   * endpoint lives here and reaches VTS as `Cdo.vendor_socket_address` (`UrlEntry`).
   * Additive trailing field — absent costs zero bytes.
   */
  opcUaEndpointUrl(): string | null;
  opcUaEndpointUrl(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  opcUaEndpointUrl(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 52);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Authoritative routing flag for this channel.
   *
   * When true, VTS routes the channel through a routed accumulation map
   * (CGA / `LobbyVision` / `LobbyVision2`) keyed on `routable_socket_address`;
   * when false, the direct vendor path is used. Auto-set true by the UI when the
   * adapter is CGA, `LobbyVision`, or `LobbyVision2`, but operator-overridable.
   * Propagated to VTS as `Cdo.routable`. Additive trailing field, absent is false.
   */
  routable(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 54);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Per-channel mTLS toggle. When true, LiftCloud-edge resolves
   * `mtls_secret_name` to client cert/key/CA bytes at CDO build time and
   * delivers them to VTS via the `Cdo.authentication` `SslCert` union, so this
   * channel's vendor connection presents its own mTLS client identity instead
   * of the global file-based one. Additive trailing field, absent is false.
   */
  mtlsEnabled(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 56);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * AWS Secrets Manager reference (secret name or ARN) for this channel's mTLS
   * client connect-bundle — an rpi-flasher `connect-bundle/v1` JSON carrying
   * `ca_cert_pem`, `client_cert_pem`, `client_key_pem`. Only the reference is
   * stored in Postgres; LiftCloud-edge fetches the bytes (`GetSecretValue`) when
   * assembling the edge CDO. VTS never reads this field — it receives resolved
   * bytes only and never talks to AWS. Additive trailing field — absent costs
   * zero bytes.
   */
  mtlsSecretName(): string | null;
  mtlsSecretName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  mtlsSecretName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 58);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Where a Control message write goes when no `ControlRoute` in
   * `control_routes` matches it. `MergePolicy` above governs the read
   * direction; this governs the write direction. Additive trailing field —
   * absent decodes as `ACTIVE_ENDPOINT`, which is the pre-existing behaviour,
   * so every existing MERGE channel keeps working with zero rules configured.
   */
  controlWriteMode(): ControlWriteMode {
    const offset = this.bb!.__offset(this.bb_pos, 60);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ControlWriteMode.ACTIVE_ENDPOINT;
  }

  /**
   * Per-control write routing rules for this channel. Only meaningful in
   * MERGE and MIXED modes; SINGLE and FAILOVER channels bypass routing.
   * Additive trailing field — an absent vector costs zero bytes.
   */
  controlRoutes(index: number, obj?: ControlRoute): ControlRoute | null {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset
      ? (obj || new ControlRoute()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  controlRoutesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 62);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startChannel(builder: flatbuffers.Builder) {
    builder.startObject(30);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addServerId(builder: flatbuffers.Builder, serverIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, serverIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addLeadingZeroesId(
    builder: flatbuffers.Builder,
    leadingZeroesIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, leadingZeroesIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, nameOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: ChannelType) {
    builder.addFieldInt8(5, type, ChannelType.TCP);
  }

  static addConnectionType(builder: flatbuffers.Builder, connectionType: ChannelType) {
    builder.addFieldInt8(6, connectionType, ChannelType.TCP);
  }

  static addIndex(builder: flatbuffers.Builder, indexOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, indexOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(8, +active, +true);
  }

  static addBaudRate(builder: flatbuffers.Builder, baudRate: number) {
    builder.addFieldInt32(9, baudRate, 9600);
  }

  static addHeartbeatFrequency(builder: flatbuffers.Builder, heartbeatFrequency: number) {
    builder.addFieldInt32(10, heartbeatFrequency, 0);
  }

  static addVendorSocketAddress(
    builder: flatbuffers.Builder,
    vendorSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(11, vendorSocketAddressOffset, 0);
  }

  static addRoutableSocketAddress(
    builder: flatbuffers.Builder,
    routableSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(12, routableSocketAddressOffset, 0);
  }

  static addReportingSocketAddress(
    builder: flatbuffers.Builder,
    reportingSocketAddressOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, reportingSocketAddressOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, deletedAtOffset, 0);
  }

  static addHeartbeatMessage(
    builder: flatbuffers.Builder,
    heartbeatMessageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(17, heartbeatMessageOffset, 0);
  }

  static addMode(builder: flatbuffers.Builder, mode: ChannelMode) {
    builder.addFieldInt8(18, mode, ChannelMode.SINGLE);
  }

  static addMergePolicy(builder: flatbuffers.Builder, mergePolicy: MergePolicy) {
    builder.addFieldInt8(19, mergePolicy, MergePolicy.LAST_WRITE_WINS);
  }

  static addEndpoints(builder: flatbuffers.Builder, endpointsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, endpointsOffset, 0);
  }

  static createEndpointsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startEndpointsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addActiveEndpointId(
    builder: flatbuffers.Builder,
    activeEndpointIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(21, activeEndpointIdOffset, 0);
  }

  static addBackfilledEndpointsAt(
    builder: flatbuffers.Builder,
    backfilledEndpointsAtOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(22, backfilledEndpointsAtOffset, 0);
  }

  static addLastFailoverAt(builder: flatbuffers.Builder, lastFailoverAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(23, lastFailoverAtOffset, 0);
  }

  static addOpcUaEndpointUrl(
    builder: flatbuffers.Builder,
    opcUaEndpointUrlOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(24, opcUaEndpointUrlOffset, 0);
  }

  static addRoutable(builder: flatbuffers.Builder, routable: boolean) {
    builder.addFieldInt8(25, +routable, +false);
  }

  static addMtlsEnabled(builder: flatbuffers.Builder, mtlsEnabled: boolean) {
    builder.addFieldInt8(26, +mtlsEnabled, +false);
  }

  static addMtlsSecretName(builder: flatbuffers.Builder, mtlsSecretNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(27, mtlsSecretNameOffset, 0);
  }

  static addControlWriteMode(builder: flatbuffers.Builder, controlWriteMode: ControlWriteMode) {
    builder.addFieldInt8(28, controlWriteMode, ControlWriteMode.ACTIVE_ENDPOINT);
  }

  static addControlRoutes(builder: flatbuffers.Builder, controlRoutesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(29, controlRoutesOffset, 0);
  }

  static createControlRoutesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startControlRoutesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endChannel(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // server_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 12); // name
    return offset;
  }

  unpack(): ChannelT {
    return new ChannelT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.serverId() !== null ? this.serverId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null,
      this.name(),
      this.type(),
      this.connectionType(),
      this.index(),
      this.active(),
      this.baudRate(),
      this.heartbeatFrequency(),
      this.vendorSocketAddress(),
      this.routableSocketAddress(),
      this.reportingSocketAddress(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.heartbeatMessage() !== null ? this.heartbeatMessage()!.unpack() : null,
      this.mode(),
      this.mergePolicy(),
      this.bb!.createObjList<ChannelEndpoint, ChannelEndpointT>(
        this.endpoints.bind(this),
        this.endpointsLength(),
      ),
      this.activeEndpointId() !== null ? this.activeEndpointId()!.unpack() : null,
      this.backfilledEndpointsAt(),
      this.lastFailoverAt(),
      this.opcUaEndpointUrl(),
      this.routable(),
      this.mtlsEnabled(),
      this.mtlsSecretName(),
      this.controlWriteMode(),
      this.bb!.createObjList<ControlRoute, ControlRouteT>(
        this.controlRoutes.bind(this),
        this.controlRoutesLength(),
      ),
    );
  }

  unpackTo(_o: ChannelT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.leadingZeroesId = this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null;
    _o.name = this.name();
    _o.type = this.type();
    _o.connectionType = this.connectionType();
    _o.index = this.index();
    _o.active = this.active();
    _o.baudRate = this.baudRate();
    _o.heartbeatFrequency = this.heartbeatFrequency();
    _o.vendorSocketAddress = this.vendorSocketAddress();
    _o.routableSocketAddress = this.routableSocketAddress();
    _o.reportingSocketAddress = this.reportingSocketAddress();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.heartbeatMessage =
      this.heartbeatMessage() !== null ? this.heartbeatMessage()!.unpack() : null;
    _o.mode = this.mode();
    _o.mergePolicy = this.mergePolicy();
    _o.endpoints = this.bb!.createObjList<ChannelEndpoint, ChannelEndpointT>(
      this.endpoints.bind(this),
      this.endpointsLength(),
    );
    _o.activeEndpointId =
      this.activeEndpointId() !== null ? this.activeEndpointId()!.unpack() : null;
    _o.backfilledEndpointsAt = this.backfilledEndpointsAt();
    _o.lastFailoverAt = this.lastFailoverAt();
    _o.opcUaEndpointUrl = this.opcUaEndpointUrl();
    _o.routable = this.routable();
    _o.mtlsEnabled = this.mtlsEnabled();
    _o.mtlsSecretName = this.mtlsSecretName();
    _o.controlWriteMode = this.controlWriteMode();
    _o.controlRoutes = this.bb!.createObjList<ControlRoute, ControlRouteT>(
      this.controlRoutes.bind(this),
      this.controlRoutesLength(),
    );
  }

  unpackFields(...fields: string[]): ChannelT {
    const t = new ChannelT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("server_id")) {
      t.serverId = this.serverId() !== null ? this.serverId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("leading_zeroes_id")) {
      t.leadingZeroesId = this.leadingZeroesId() !== null ? this.leadingZeroesId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("connection_type")) {
      t.connectionType = this.connectionType();
    }
    if (fieldSet.has("index")) {
      t.index = this.index();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("baud_rate")) {
      t.baudRate = this.baudRate();
    }
    if (fieldSet.has("heartbeat_frequency")) {
      t.heartbeatFrequency = this.heartbeatFrequency();
    }
    if (fieldSet.has("vendor_socket_address")) {
      t.vendorSocketAddress = this.vendorSocketAddress();
    }
    if (fieldSet.has("routable_socket_address")) {
      t.routableSocketAddress = this.routableSocketAddress();
    }
    if (fieldSet.has("reporting_socket_address")) {
      t.reportingSocketAddress = this.reportingSocketAddress();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("heartbeat_message")) {
      t.heartbeatMessage =
        this.heartbeatMessage() !== null ? this.heartbeatMessage()!.unpack() : null;
    }
    if (fieldSet.has("mode")) {
      t.mode = this.mode();
    }
    if (fieldSet.has("merge_policy")) {
      t.mergePolicy = this.mergePolicy();
    }
    if (fieldSet.has("endpoints")) {
      t.endpoints = this.bb!.createObjList<ChannelEndpoint, ChannelEndpointT>(
        this.endpoints.bind(this),
        this.endpointsLength(),
      );
    }
    if (fieldSet.has("active_endpoint_id")) {
      t.activeEndpointId =
        this.activeEndpointId() !== null ? this.activeEndpointId()!.unpack() : null;
    }
    if (fieldSet.has("backfilled_endpoints_at")) {
      t.backfilledEndpointsAt = this.backfilledEndpointsAt();
    }
    if (fieldSet.has("last_failover_at")) {
      t.lastFailoverAt = this.lastFailoverAt();
    }
    if (fieldSet.has("opc_ua_endpoint_url")) {
      t.opcUaEndpointUrl = this.opcUaEndpointUrl();
    }
    if (fieldSet.has("routable")) {
      t.routable = this.routable();
    }
    if (fieldSet.has("mtls_enabled")) {
      t.mtlsEnabled = this.mtlsEnabled();
    }
    if (fieldSet.has("mtls_secret_name")) {
      t.mtlsSecretName = this.mtlsSecretName();
    }
    if (fieldSet.has("control_write_mode")) {
      t.controlWriteMode = this.controlWriteMode();
    }
    if (fieldSet.has("control_routes")) {
      t.controlRoutes = this.bb!.createObjList<ControlRoute, ControlRouteT>(
        this.controlRoutes.bind(this),
        this.controlRoutesLength(),
      );
    }
    return t;
  }
}

export class ChannelT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public serverId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public leadingZeroesId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public type: ChannelType = ChannelType.TCP,
    public connectionType: ChannelType = ChannelType.TCP,
    public index: string | Uint8Array | null = null,
    public active: boolean = true,
    public baudRate: number = 9600,
    public heartbeatFrequency: number = 0,
    public vendorSocketAddress: string | Uint8Array | null = null,
    public routableSocketAddress: string | Uint8Array | null = null,
    public reportingSocketAddress: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public heartbeatMessage: MessageT | null = null,
    public mode: ChannelMode = ChannelMode.SINGLE,
    public mergePolicy: MergePolicy = MergePolicy.LAST_WRITE_WINS,
    public endpoints: ChannelEndpointT[] = [],
    public activeEndpointId: UuidT | null = null,
    public backfilledEndpointsAt: string | Uint8Array | null = null,
    public lastFailoverAt: string | Uint8Array | null = null,
    public opcUaEndpointUrl: string | Uint8Array | null = null,
    public routable: boolean = false,
    public mtlsEnabled: boolean = false,
    public mtlsSecretName: string | Uint8Array | null = null,
    public controlWriteMode: ControlWriteMode = ControlWriteMode.ACTIVE_ENDPOINT,
    public controlRoutes: ControlRouteT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.serverId === null || this.serverId === undefined) {
      throw new Error('Required field "server_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const serverId = this.serverId !== null ? this.serverId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const leadingZeroesId = this.leadingZeroesId !== null ? this.leadingZeroesId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const index = this.index !== null ? builder.createString(this.index!) : 0;
    const vendorSocketAddress =
      this.vendorSocketAddress !== null ? builder.createString(this.vendorSocketAddress!) : 0;
    const routableSocketAddress =
      this.routableSocketAddress !== null ? builder.createString(this.routableSocketAddress!) : 0;
    const reportingSocketAddress =
      this.reportingSocketAddress !== null ? builder.createString(this.reportingSocketAddress!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const heartbeatMessage =
      this.heartbeatMessage !== null ? this.heartbeatMessage!.pack(builder) : 0;
    const endpoints = Channel.createEndpointsVector(
      builder,
      builder.createObjectOffsetList(this.endpoints),
    );
    const activeEndpointId =
      this.activeEndpointId !== null ? this.activeEndpointId!.pack(builder) : 0;
    const backfilledEndpointsAt =
      this.backfilledEndpointsAt !== null ? builder.createString(this.backfilledEndpointsAt!) : 0;
    const lastFailoverAt =
      this.lastFailoverAt !== null ? builder.createString(this.lastFailoverAt!) : 0;
    const opcUaEndpointUrl =
      this.opcUaEndpointUrl !== null ? builder.createString(this.opcUaEndpointUrl!) : 0;
    const mtlsSecretName =
      this.mtlsSecretName !== null ? builder.createString(this.mtlsSecretName!) : 0;
    const controlRoutes = Channel.createControlRoutesVector(
      builder,
      builder.createObjectOffsetList(this.controlRoutes),
    );

    Channel.startChannel(builder);
    Channel.addId(builder, id);
    Channel.addServerId(builder, serverId);
    Channel.addOrganizationId(builder, organizationId);
    Channel.addLeadingZeroesId(builder, leadingZeroesId);
    Channel.addName(builder, name);
    Channel.addType(builder, this.type);
    Channel.addConnectionType(builder, this.connectionType);
    Channel.addIndex(builder, index);
    Channel.addActive(builder, this.active);
    Channel.addBaudRate(builder, this.baudRate);
    Channel.addHeartbeatFrequency(builder, this.heartbeatFrequency);
    Channel.addVendorSocketAddress(builder, vendorSocketAddress);
    Channel.addRoutableSocketAddress(builder, routableSocketAddress);
    Channel.addReportingSocketAddress(builder, reportingSocketAddress);
    Channel.addCreatedAt(builder, createdAt);
    Channel.addUpdatedAt(builder, updatedAt);
    Channel.addDeletedAt(builder, deletedAt);
    Channel.addHeartbeatMessage(builder, heartbeatMessage);
    Channel.addMode(builder, this.mode);
    Channel.addMergePolicy(builder, this.mergePolicy);
    Channel.addEndpoints(builder, endpoints);
    Channel.addActiveEndpointId(builder, activeEndpointId);
    Channel.addBackfilledEndpointsAt(builder, backfilledEndpointsAt);
    Channel.addLastFailoverAt(builder, lastFailoverAt);
    Channel.addOpcUaEndpointUrl(builder, opcUaEndpointUrl);
    Channel.addRoutable(builder, this.routable);
    Channel.addMtlsEnabled(builder, this.mtlsEnabled);
    Channel.addMtlsSecretName(builder, mtlsSecretName);
    Channel.addControlWriteMode(builder, this.controlWriteMode);
    Channel.addControlRoutes(builder, controlRoutes);

    return Channel.endChannel(builder);
  }

  clone(): ChannelT {
    const obj = new ChannelT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.serverId = this.serverId !== null ? this.serverId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.leadingZeroesId = this.leadingZeroesId !== null ? this.leadingZeroesId!.clone() : null;
    obj.name = this.name;
    obj.type = this.type;
    obj.connectionType = this.connectionType;
    obj.index = this.index;
    obj.active = this.active;
    obj.baudRate = this.baudRate;
    obj.heartbeatFrequency = this.heartbeatFrequency;
    obj.vendorSocketAddress = this.vendorSocketAddress;
    obj.routableSocketAddress = this.routableSocketAddress;
    obj.reportingSocketAddress = this.reportingSocketAddress;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.heartbeatMessage = this.heartbeatMessage !== null ? this.heartbeatMessage!.clone() : null;
    obj.mode = this.mode;
    obj.mergePolicy = this.mergePolicy;
    obj.endpoints = this.endpoints.map((e) => e.clone());
    obj.activeEndpointId = this.activeEndpointId !== null ? this.activeEndpointId!.clone() : null;
    obj.backfilledEndpointsAt = this.backfilledEndpointsAt;
    obj.lastFailoverAt = this.lastFailoverAt;
    obj.opcUaEndpointUrl = this.opcUaEndpointUrl;
    obj.routable = this.routable;
    obj.mtlsEnabled = this.mtlsEnabled;
    obj.mtlsSecretName = this.mtlsSecretName;
    obj.controlWriteMode = this.controlWriteMode;
    obj.controlRoutes = this.controlRoutes.map((e) => e.clone());
    return obj;
  }

  equals(other: ChannelT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.serverId !== null && other.serverId !== null) {
      if (!this.serverId!.equals(other.serverId!)) return false;
    } else if (this.serverId !== other.serverId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.leadingZeroesId !== null && other.leadingZeroesId !== null) {
      if (!this.leadingZeroesId!.equals(other.leadingZeroesId!)) return false;
    } else if (this.leadingZeroesId !== other.leadingZeroesId) return false;
    if (this.name !== other.name) return false;
    if (this.type !== other.type) return false;
    if (this.connectionType !== other.connectionType) return false;
    if (this.index !== other.index) return false;
    if (this.active !== other.active) return false;
    if (this.baudRate !== other.baudRate) return false;
    if (this.heartbeatFrequency !== other.heartbeatFrequency) return false;
    if (this.vendorSocketAddress !== other.vendorSocketAddress) return false;
    if (this.routableSocketAddress !== other.routableSocketAddress) return false;
    if (this.reportingSocketAddress !== other.reportingSocketAddress) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.heartbeatMessage !== null && other.heartbeatMessage !== null) {
      if (!this.heartbeatMessage!.equals(other.heartbeatMessage!)) return false;
    } else if (this.heartbeatMessage !== other.heartbeatMessage) return false;
    if (this.mode !== other.mode) return false;
    if (this.mergePolicy !== other.mergePolicy) return false;
    if (this.endpoints.length !== other.endpoints.length) return false;
    for (let i = 0; i < this.endpoints.length; i++) {
      const a = this.endpoints[i];
      const b = other.endpoints[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.activeEndpointId !== null && other.activeEndpointId !== null) {
      if (!this.activeEndpointId!.equals(other.activeEndpointId!)) return false;
    } else if (this.activeEndpointId !== other.activeEndpointId) return false;
    if (this.backfilledEndpointsAt !== other.backfilledEndpointsAt) return false;
    if (this.lastFailoverAt !== other.lastFailoverAt) return false;
    if (this.opcUaEndpointUrl !== other.opcUaEndpointUrl) return false;
    if (this.routable !== other.routable) return false;
    if (this.mtlsEnabled !== other.mtlsEnabled) return false;
    if (this.mtlsSecretName !== other.mtlsSecretName) return false;
    if (this.controlWriteMode !== other.controlWriteMode) return false;
    if (this.controlRoutes.length !== other.controlRoutes.length) return false;
    for (let i = 0; i < this.controlRoutes.length; i++) {
      const a = this.controlRoutes[i];
      const b = other.controlRoutes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyChannel(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "server_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "name");
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 38);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 40, 1);
    verifier.checkScalarField(tablePos, 42, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyChannelEndpoint);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 46);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 48);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 50);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 52);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 54, 1);
    verifier.checkScalarField(tablePos, 56, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 58);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 60, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 62);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyControlRoute);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
